import React from "react";

interface GearSetItem {
  id: number;
  equipment_name?: string;
  name?: string;
  category?: string;
  status?: string;
  quantity?: number;
}

export interface PrintableGearSet {
  id: number;
  name: string;
  description: string;
  items?: GearSetItem[];
}

interface PrintableGearProps {
  gearSet: PrintableGearSet | null;
}

const PrintableGear = React.forwardRef<HTMLDivElement, PrintableGearProps>(
  ({ gearSet }, ref) => (
    <div
      ref={ref}
      style={{
        width: "794px",
        padding: "20mm",
        fontFamily: "Arial, sans-serif",
        fontSize: "12px",
        backgroundColor: "#fff",
        color: "#000",
        boxSizing: "border-box",
      }}
    >
      <h2
        style={{
          borderBottom: "2px solid #333",
          paddingBottom: "8px",
          marginBottom: "16px",
          fontSize: "18px",
          justifyContent: "center",
          display: "flex",
        }}
      >
        Gear: {gearSet?.name || "No set allocated"}
      </h2>

      {gearSet?.description && (
        <p style={{ marginBottom: "16px", fontSize: "11px", color: "#555" }}>
          {gearSet.description}
        </p>
      )}

      {!gearSet || !gearSet.items?.length ? (
        <p style={{ color: "#888" }}>No gear items found.</p>
      ) : (
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ backgroundColor: "#f0f0f0" }}>
              {["#", "Name", "Category", "Qty"].map((h) => (
                <th
                  key={h}
                  style={{
                    border: "1px solid #ddd",
                    padding: "6px 8px",
                    textAlign: "left",
                    fontWeight: "bold",
                    fontSize: "11px",
                  }}
                >
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {gearSet.items.map((item, index) => (
              <tr
                key={item.id}
                style={{
                  backgroundColor: index % 2 === 0 ? "#fff" : "#fafafa",
                }}
              >
                <td style={{ border: "1px solid #ddd", padding: "6px 8px", width: "32px" }}>
                  {index + 1}
                </td>
                <td style={{ border: "1px solid #ddd", padding: "6px 8px" }}>
                  {item.equipment_name || item.name || "—"}
                </td>
                <td style={{ border: "1px solid #ddd", padding: "6px 8px" }}>
                  {item.category || "—"}
                </td>
                {/* <td style={{ border: "1px solid #ddd", padding: "6px 8px" }}>
                  {item.status || "Available"}
                </td> */}
                <td style={{ border: "1px solid #ddd", padding: "6px 8px", textAlign: "center" }}>
                  {item.quantity || 1}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  )
);

PrintableGear.displayName = "PrintableGear";

export default PrintableGear;